<script>
import {Doughnut} from "vue-chartjs";

export default {
  name: "Chart",
  extends: Doughnut,
  data: () => ({
    chartdata: {
      labels: ["Отклонено", "Отказ подающего", "Оформлена"],
      datasets: [
        {
          backgroundColor: ["#F5A623", "#FF4B78", "#B3A0DC"],
          data: [23, 32, 75]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 1,
      cutoutPercentage: 80,
      legend: {
        display: false
        //          position: 'right',
        //          align: 'start',
        //          labels: {
        //            fontColor: '#42474C',
        //            fontSize: 14,
        //            usePointStyle: true,
        //            padding: 30,
        //          },
      }
    }
  }),

  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>

<style>
</style>
